import { useGetIglooWorksStatus } from '@/api/property-keyless/igloo-works/get-igloo-works-status'

import { iglooWorksDefaultValues } from './igloo-works.schema'

const stringifyDoors = (doors: Record<string, string> | undefined) =>
  doors && Object.keys(doors).length > 0 ? JSON.stringify(doors) : ''

// Note: clientSecret is intentionally never pre-filled — the GET response never returns it
// (write-only), and connect is a full overwrite, so it must be re-entered on every submit
// (see use-igloo-works-submit.ts).
export const useIglooWorksConnection = (buildingId: number) => {
  const { data, isSuccess, isLoading } = useGetIglooWorksStatus({ buildingId })

  const values = {
    ...iglooWorksDefaultValues,
    clientId: data?.clientId ?? '',
    permissionDoors: stringifyDoors(data?.config?.permissionDoors),
    shouldAutoAssignApartmentDoor: data?.config?.shouldAutoAssignApartmentDoor ?? false,
    shouldAutoAssignApartmentDoorVisitor:
      data?.config?.shouldAutoAssignApartmentDoorVisitor ?? false,
    visitorPermissionDoors: stringifyDoors(data?.config?.visitorPermissionDoors),
  }

  return { isConfigured: isSuccess, isLoading, values }
}
